<div class="trip-detail-popup-right">
  <img
    src="../../../assets/img/icons8-macos-close-60.png"
    class="close-icons"
    (click)="close()"
  />
</div>
<form class="admin-forms" [formGroup]="preOrderForm">
  <div class="accordion-class">
    <h5>Edit PN ID #{{data.workorder_id}}</h5>
    <mat-divider></mat-divider>
    <div class="row mt-2">
      <div class="col-sm-12 d-flex align-items-center">
        <div class="col-sm-5">
          <span> WO Price :</span>
        </div>
        <div class="col-sm-7">
          <mat-form-field class="no-error-underline" appearance="fill">
            <input
              matInput
              formControlName="wo_price"
              placeholder="WO Price"
              (input)="limitDecimalPlaces($event)"
              readonly
            />
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-sm-12 d-flex align-items-center">
        <div class="col-sm-5">
          <span>S9 Price :</span>
        </div>
        <div class="col-sm-7">
          <mat-form-field class="no-error-underline" appearance="fill">
            <input
              matInput
              formControlName="margin"
              placeholder="S9 Price"
              required
            />
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-sm-12 d-flex align-items-center">
        <div class="col-sm-5">
          <span>Increase Timer :</span>
        </div>
        <div class="col-sm-7">
          <mat-form-field class="no-error-underline" appearance="fill">
            <input
              matInput
              formControlName="increase_timer"
              placeholder="Increase Timer"
              maxlength="3"
              (input)="formatTime($event)"
              required
            />
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 d-flex align-items-center justify-content-center">
        <button
          type="button"
          [disabled]="!preOrderForm.valid"
          [ngClass]="{ 'button-disabled': !preOrderForm.valid }"
          class="button buttonCancel my-3"
          (click)="Update()"
        >
          SUBMIT
        </button>
      </div>
    </div>
  </div>
</form>
